import React from "react";
import "./experiences.css";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Experiences = () => {
  return (
    <>
      <div className="exp_container" id="Experience">
        <div className="top_exp_Text">
          <h1>Experience</h1>
        </div>
        <div className="center_exp_container">
          <div className="exp_grid_container">
            <div className="exp_G_items">
              <div className="exp_items_bdy">
                <div className="exp_profile">
                  <CastForEducationIcon className="exp_icons" fontSize="35px" />
                </div>
                <p>2014-15 </p>
                <h2>Master of Computer Application</h2>
                <p>
                  
                  <LocationOnIcon /> Google Inc.
                </p>
                <p>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui
                  voluptates aliquam accusantium, minus similique deleniti?
                </p>
              </div>
            </div>
            <div className="exp_G_items">
              <div className="exp_items_bdy">
                <div className="exp_profile">
                  <CastForEducationIcon className="exp_icons" fontSize="35px" />
                </div>
                <p>2014-15 </p>
                <h2>Master of Computer Application</h2>
                <p>
                  
                  <LocationOnIcon /> Google Inc.
                </p>
                <p>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui
                  voluptates aliquam accusantium, minus similique deleniti?
                </p>
              </div>
            </div>
            <div className="exp_G_items">
              <div className="exp_items_bdy">
                <div className="exp_profile">
                  <CastForEducationIcon className="exp_icons" fontSize="35px" />
                </div>
                <p>2014-15 </p>
                <h2>Master of Computer Application</h2>
                <p>
                  
                  <LocationOnIcon /> Google Inc.
                </p>
                <p>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui
                  voluptates aliquam accusantium, minus similique deleniti?
                </p>
              </div>
            </div>
            <div className="exp_G_items">
              <div className="exp_items_bdy">
                <div className="exp_profile">
                  <CastForEducationIcon className="exp_icons" fontSize="35px" />
                </div>
                <p>2014-15 </p>
                <h2>Master of Computer Application</h2>
                <p>
                  
                  <LocationOnIcon /> Google Inc.
                </p>
                <p>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Qui
                  voluptates aliquam accusantium, minus similique deleniti?
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Experiences;
